export const getCurrentLanguage = (): string => {
  return localStorage.getItem('locale') || (import.meta.env.VITE_DEFAULT_LOCALE || 'en');
};
